/**
 * The saturator's processor: the first effect here written as DSP rather than
 * wired from platform nodes.
 *
 * A soft clip — `tanh(x·drive)` — folds the peaks of a waveform over, which
 * adds the odd harmonics that make a sine sound like it went through a
 * transformer or a tube. Divided by `tanh(drive)` so a full-scale peak stays
 * full-scale: the knob adds harmonics, not level. `drive` is an a-rate
 * parameter, so an automation ramp reaches every sample rather than every
 * block.
 *
 * The source is a string, loaded through `WorkletModule` once per context: a
 * worklet module is fetched by URL, and a blob URL of this text is a URL the
 * bundler never has to know about.
 */
import { WorkletModule } from '../workletModule';

export const SATURATOR_PROCESSOR = 'stage-zero-saturator';

export const saturatorModule = new WorkletModule(`
class StageZeroSaturator extends AudioWorkletProcessor {
  static get parameterDescriptors() {
    return [{ name: 'drive', defaultValue: 1, minValue: 1, maxValue: 20, automationRate: 'a-rate' }];
  }
  process(inputs, outputs, parameters) {
    const input = inputs[0];
    const output = outputs[0];
    const drive = parameters.drive;
    const perSample = drive.length > 1;
    let norm = 1 / Math.tanh(drive[0]);
    for (let c = 0; c < output.length; c++) {
      const out = output[c];
      const inp = input[c];
      if (!inp) {
        out.fill(0);
        continue;
      }
      for (let i = 0; i < out.length; i++) {
        const k = perSample ? drive[i] : drive[0];
        if (perSample) norm = 1 / Math.tanh(k);
        out[i] = Math.tanh(inp[i] * k) * norm;
      }
    }
    return true;
  }
}
registerProcessor('${SATURATOR_PROCESSOR}', StageZeroSaturator);
`);
